// Single AuthClient instance per app. Same-origin /api/{serviceId}/* via the
// dev proxy (vite.config.ts) and the AFD path-route in prod — mf-auth-adapter
// is the BFF, mounted at /auth/*.
import { AuthClient } from "@mf/auth-client";

export const authClient = new AuthClient({ baseUrl: "/api/mf-auth-adapter/auth" });
